import { Component, computed, inject, input } from '@angular/core';
import { SharedCommonModule } from '@shared/common.module';
import { mobileMenuStyles } from './mobile-menu.variants';
import { MenuContent, MenuItemContent } from '../types';
import { EduIconComponent } from '@atoms/icon/icon.component';
import { Router, RouterLink } from '@angular/router';
import { MenuService } from '@shared/services/menu.service';

@Component({
  selector: 'edu-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  imports: [SharedCommonModule, EduIconComponent, RouterLink],
})
export class MobileMenuComponent {
  private menuService = inject(MenuService);
  private router = inject(Router);

  menuContents = input.required<MenuContent[]>();

  filteredMenuItems = computed(() => this.menuService.flattenMenuContents(this.menuContents()));

  get styles() {
    return mobileMenuStyles();
  }

  getLinkClassesForItem(item: MenuItemContent) {
    return mobileMenuStyles({
      active: item.route
        ? this.router.isActive(item.route, {
            paths: 'subset',
            queryParams: 'ignored',
            fragment: 'ignored',
            matrixParams: 'ignored',
            ...item.isActiveMatchOptions,
          })
        : false,
    });
  }
}
